import React from "react";
import {useSelector, useDispatch} from "react-redux";
import {useEffect, useState} from "react";
import {
  getRecentlyAddedResourcesAWS,
  getRecentlyAddedResourcesGCP,
  getRecentlyAddedResourcesAzure,
  getRecentlyAddedResourcesDatadog,
  getRecentlyAddedResourcesNewRelic,
  getRecentlyAddedResourcesAppDynamics,
  getRecentlyAddedResourcesSplunk,
  getRecentlyAddedResourcesDynatrace,
  getRecentlyAddedResourcesSynthetics,
  getRecentlyAddedResourcesOci, getRecentlyAddedResourcesGrafana, getRecentlyAddedResourcesSignoz
} from "store/actions";
import {Link} from "react-router-dom";
import ResourcesTable from "./ResourcesTable";
import {Dropdown, DropdownMenu, DropdownToggle, DropdownItem, Button, Pagination, PaginationItem, PaginationLink} from "reactstrap";
import Service from "../../store/service/reducer";

const RecentlyAddedResources = ({monitoringSystems, height, maxHeight, itemsPerPage}) => {
  const dispatch = useDispatch();
  const {AWSResources} = useSelector(state => ({
    AWSResources: state.Dashboard.data
  }))
  const {AzureResources} = useSelector(state => ({
    AzureResources: state.Dashboard.AzureData
  }))
  const {GCPResources} = useSelector(state => ({
    GCPResources: state.Dashboard.GCPData
  }))
  const {DatadogResources} = useSelector(state => ({
    DatadogResources: state.Dashboard.DatadogData
  }))
  const {NewRelicResources} = useSelector(state => ({
    NewRelicResources: state.Dashboard.NewRelicData
  }))
  const {AppDynamicsResources} = useSelector(state => ({
    AppDynamicsResources: state.Dashboard.AppDynamicsResources
  }))

  const {SplunkResources} = useSelector(state => ({
    SplunkResources: state.Dashboard.SplunkResources
  }))

  const {SyntheticsResources} = useSelector(state => ({
    SyntheticsResources: state.Dashboard.SyntheticsResources
  }))

  const {DynatraceResources} = useSelector(state => ({
    DynatraceResources: state.Dashboard.DynatraceResources
  }))

  const {AWSResourceCount} = useSelector(state => ({
    AWSResourceCount: state.Dashboard.AWSCount
  }))

  const {GCPResourceCount} = useSelector(state => ({
    GCPResourceCount: state.Dashboard.GCPCount
  }))

  const {AzureResourceCount} = useSelector(state => ({
    AzureResourceCount: state.Dashboard.AzureCount
  }))

  const {DatadogResourceCount} = useSelector(state => ({
    DatadogResourceCount: state.Dashboard.DatadogCount
  }))

  const {NRResourceCount} = useSelector(state => ({
    NRResourceCount: state.Dashboard.NRCount
  }))

  const {AppDynamicsCount} = useSelector(state => ({
    AppDynamicsCount: state.Dashboard.AppDynamicsCount
  }))

  const {SplunkCount} = useSelector(state => ({
    SplunkCount: state.Dashboard.SplunkCount
  }))

  const {DynatraceCount} = useSelector(state => ({
    DynatraceCount: state.Dashboard.DynatraceCount
  }))

  const {SyntheticsCount} = useSelector(state => ({
    SyntheticsCount: state.Dashboard.SyntheticsCount
  }))

  const {OciResources} = useSelector(state => ({
    OciResources: state.Dashboard.OciResources
  }))

  const {OciCount} = useSelector(state => ({
    OciCount: state.Dashboard.OciCount
  }))

  const {GrafanaCount} = useSelector(state => ({
    GrafanaCount: state.Dashboard.GrafanaCount
  }))
  const {GrafanaResources} = useSelector(state => ({
    GrafanaResources: state.Dashboard.GrafanaResources
  }))

  const {SignozCount} = useSelector(state => ({
    SignozCount: state.Dashboard.SignozCount
  }))
  const {SignozResources} = useSelector(state => ({
    SignozResources: state.Dashboard.SignozResources
  }))

  const [integrated_systems, setIntegratedSystems] = useState([]);
  const [currentType, setCurrentType] = useState(integrated_systems[0] || 'AWS');
  const [noOfDays, setNoOfDays] = useState(7);
  const [payload, setPayload] = useState({'last_number_of_days': noOfDays, 'per_page': itemsPerPage})

  const count = {
    'AWS': AWSResourceCount,
    'GCP': GCPResourceCount,
    'Azure': AzureResourceCount,
    'Datadog': DatadogResourceCount,
    'NewRelic': NRResourceCount,
    'AppDynamics': AppDynamicsCount,
    'Grafana': GrafanaCount,
    'Splunk': SplunkCount,
    'Dynatrace': DynatraceCount,
    'Temperstack':SyntheticsCount,
    'Signoz': SignozCount
  }

  const all_monitoring_systems = {
    'Amazon Web Services': 'AWS',
    'New Relic': 'NewRelic',
    'Datadog': 'Datadog',
    'Google Cloud Platform': 'GCP',
    'Microsoft Azure': 'Azure',
    'App Dynamics' : 'AppDynamics',
    'Splunk': 'Splunk',
    'Dynatrace': 'Dynatrace',
    'Temperstack': 'Temperstack',
    'Oracle Cloud Infrastructure': 'OCI',
    'Grafana': 'Grafana',
    'Signoz': 'Signoz',
  };

  const forDispatch = {
    'AWS': getRecentlyAddedResourcesAWS,
    'GCP': getRecentlyAddedResourcesGCP,
    'Azure': getRecentlyAddedResourcesAzure,
    'Datadog': getRecentlyAddedResourcesDatadog,
    'NewRelic': getRecentlyAddedResourcesNewRelic,
    'AppDynamics': getRecentlyAddedResourcesAppDynamics,
    'Splunk': getRecentlyAddedResourcesSplunk,
    'Dynatrace': getRecentlyAddedResourcesDynatrace,
    'Temperstack': getRecentlyAddedResourcesSynthetics,
    "OCI": getRecentlyAddedResourcesOci,
    'Grafana' : getRecentlyAddedResourcesGrafana,
    'Signoz' : getRecentlyAddedResourcesSignoz
  }
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [allPagerdutyServices, setAllPagerdutyServices] = useState({});

  const [selectedPage, setSelectedPage] = useState(1);
  const [totalResources, setTotalResources] = useState(count[currentType] || 0);
  const [totalPages, setTotalPages] = useState(Math.ceil(totalResources / itemsPerPage))

  const updateNoOfDays = (days) => {
    setNoOfDays(days);
    setPayload(prevPayload => ({
      ...prevPayload,
      'page': 1,
      'per_page': itemsPerPage,
      'last_number_of_days': days
    }));
    dispatch(forDispatch[currentType](payload));
  }
  let startPage = Math.max(selectedPage - 1, 1);
  let endPage = Math.min(startPage + 2, totalPages);
  if (endPage === totalPages) {
    startPage = Math.max(totalPages - 2, 1);
  }

  const handlePageClick = (pageNumber) => {
    setPayload(prevPayload => ({
      ...prevPayload,
      'page': pageNumber,
      'per_page': itemsPerPage,
      'last_number_of_days': noOfDays
    }));

    setSelectedPage(pageNumber);
    dispatch(forDispatch[currentType](payload));
  }

  useEffect(() => {
    if (count[currentType] < 4) {
      setSelectedPage(1)
    }
    setPayload({
      'page': selectedPage,
      'per_page': itemsPerPage,
      'last_number_of_days': noOfDays
    })

    dispatch(getRecentlyAddedResourcesAzure(payload))
    dispatch(getRecentlyAddedResourcesAWS(payload));
    dispatch(getRecentlyAddedResourcesGCP(payload))
    dispatch(getRecentlyAddedResourcesDatadog(payload))
    dispatch(getRecentlyAddedResourcesNewRelic(payload))
    dispatch(getRecentlyAddedResourcesAppDynamics(payload))
    dispatch(getRecentlyAddedResourcesSplunk(payload))
    dispatch(getRecentlyAddedResourcesDynatrace(payload))
    dispatch(getRecentlyAddedResourcesSynthetics(payload))
    dispatch(getRecentlyAddedResourcesOci(payload))
    dispatch(getRecentlyAddedResourcesGrafana(payload))
    dispatch(getRecentlyAddedResourcesSignoz(payload))

    setTotalResources(count[currentType] || 0)

    setTotalPages(Math.ceil(totalResources / itemsPerPage))

    startPage = Math.max(selectedPage - 1, 1);
    endPage = Math.min(startPage + 2, totalPages);
    if (endPage === totalPages) {
      startPage = Math.max(totalPages - 2, 1);
    }

  }, [getRecentlyAddedResourcesAWS,
    getRecentlyAddedResourcesGCP,
    getRecentlyAddedResourcesAzure,
    getRecentlyAddedResourcesDatadog,
    getRecentlyAddedResourcesNewRelic,
    getRecentlyAddedResourcesAppDynamics,
    getRecentlyAddedResourcesSplunk,
    getRecentlyAddedResourcesDynatrace,
    getRecentlyAddedResourcesSynthetics,
    getRecentlyAddedResourcesOci,
    getRecentlyAddedResourcesGrafana,
    getRecentlyAddedResourcesSignoz,
    noOfDays, setDropdownOpen, currentType, totalResources, totalPages, selectedPage, count[currentType]]);

  let opsGenieTeamOptions = [];
  let opsGenieTeamValue = {}

  let pagerdutyServiceOptions = [];
  let pagerdutyServiceValue = {}
  const {opsgenie_teams} = useSelector(state => ({
    opsgenie_teams: state.OpsGenieTeams.opsgenie_teams,
  }));

  const {pagerduty_services} = useSelector(state => ({
    pagerduty_services: state.PagerdutyServices.pagerduty_services,
  }));

  const {application_services} = useSelector(state => ({
    application_services: state.Service.services
  }));

  const [allOpsGenieTeams, setAllOpsGenieTeams] = useState({});

  const [allServices, setAllServices] = useState({});

  application_services.map((application_service) => {
    allServices[application_service.id] = application_service.name;
  });

  opsgenie_teams.map((opsgenie_team) => {
    allOpsGenieTeams[opsgenie_team.id] = opsgenie_team.name;
    opsGenieTeamOptions.push({value: opsgenie_team.id, label: opsgenie_team.name});
    opsGenieTeamValue[opsgenie_team.id] = {value: opsgenie_team.id, label: opsgenie_team.name}
  });

  pagerduty_services.map((pagerduty_service) => {
    allPagerdutyServices[pagerduty_service.id] = pagerduty_service.name;
    pagerdutyServiceOptions.push({value: pagerduty_service.id, label: pagerduty_service.name});
    pagerdutyServiceValue[pagerduty_service.id] = {value: pagerduty_service.id, label: pagerduty_service.name}
  });

  const filteredSystems = []
  let {current_notification_channels} = useSelector(state => ({
    current_notification_channels: state.Dashboard.notification_channels || []
  }));

  function getNotificationServiceMapping(cloud_resource) {
    for (let notification_channel of current_notification_channels) {
      if (notification_channel.name === "OpsGenie" && notification_channel.is_primary === true) {
        if (cloud_resource.opsgenie_team_id !== null) {
          return <div className="mb-2 bg-transparent">
            {allOpsGenieTeams[cloud_resource.opsgenie_team_id]}
          </div>
        } else {
          return <div className="mb-2 bg-transparent"> - </div>
        }
      } else if (notification_channel.name === "Email" && notification_channel.is_primary === true) {
        if (cloud_resource.application_service_id !== null) {
          return <Link
            to={`/temperstack-notifications/${cloud_resource?.application_service_id}`}
            className="link-primary bg-transparent"
          >
            <div className="mb-2 bg-transparent">
              {allServices[cloud_resource.application_service_id]}
            </div>
          </Link>
        } else {
          return <div className="mb-2 bg-transparent"> - </div>
        }
      } else if (notification_channel.name === "PagerDuty" && notification_channel.is_primary === true) {
        if (cloud_resource.pagerduty_service_id !== null) {
          return <div className="mb-2 bg-transparent">
            {allPagerdutyServices[cloud_resource.pagerduty_service_id]}
          </div>
        } else {
          return <div className="mb-2 bg-transparent"> - </div>
        }
      }
    }
    return <div className="mb-2 bg-transparent"> - </div>
  }

  useEffect(() => {
    monitoringSystems.forEach((monitoringSystem) => {
      Object.keys(all_monitoring_systems).forEach((monitoring_system_name) => {
        if (monitoringSystem.name === monitoring_system_name) {
          filteredSystems.push(all_monitoring_systems[monitoring_system_name]);
        }
      })
    })
    setIntegratedSystems(filteredSystems);
  }, [monitoringSystems])

  useEffect(() => {
    setCurrentType( 'AWS' || 'Azure' || 'GCP' || 'Datadog' || 'NewRelic' || 'AppDynamics' || 'Splunk' ||
                   'Dynatrace' || 'Temperstack' || 'OCI' || 'Grafana' ||'Signoz');
  },[integrated_systems.length])

  const toggle = () => setDropdownOpen((prevState) => !prevState);

  const chooseResourceType = (resourceName) => {
    setSelectedPage(1);
    setCurrentType(resourceName);
    setTotalResources(count[currentType] || 0)
    setTotalPages(Math.ceil(totalResources / itemsPerPage));
    setPayload(prevPayload => ({
      ...prevPayload,
      'page': 1,
      'per_page': itemsPerPage,
      'last_number_of_days': noOfDays
    }));

    dispatch(forDispatch[currentType](payload));
  }

  return (
    <React.Fragment>
      <div className="d-flex pe-2" style={{justifyContent: "space-between"}}>
        <div className="d-flex p-2 gap-3 align-items-center">
          <h4 className="card-title">Recently Added Resources</h4>
          <Dropdown isOpen={dropdownOpen} style={{color: ""}} toggle={toggle} direction={"down"}>
            <DropdownToggle color="primary" style={{ border:"none"}} caret>Last {noOfDays} {(noOfDays !== 1) ? 'days' : 'day'}
              <div className="bx bx-caret-down ps-1"></div>
            </DropdownToggle>
            <DropdownMenu>
              <DropdownItem onClick={() => updateNoOfDays(7)}>Last 7 days</DropdownItem>
              <DropdownItem onClick={() => updateNoOfDays(5)}>Last 5 days</DropdownItem>
              <DropdownItem onClick={() => updateNoOfDays(3)}>Last 3 days</DropdownItem>
              <DropdownItem onClick={() => updateNoOfDays(1)}>Yesterday</DropdownItem>
            </DropdownMenu>
          </Dropdown>

        </div>
        <div>
          {height !== "100%" && <Link to="/recently-added-resources">
            <Button className="btn-soft-primary">View More</Button>
          </Link>}
        </div>
      </div>
      <div className="nav-tabs-custom nav-justified nav nav-tabs align-items-center" style={{justifyContent: "space-between"}}>
        <div>
          <ul className="nav-tabs-custom nav-justified nav nav-tabs">

            {(integrated_systems.includes('AWS') && AWSResources) &&
              <li onClick={() => chooseResourceType('AWS')} className="nav-item">
                <a className={`${currentType === 'AWS' && 'active'} nav-link`}>
             <span className="d-block d-sm-none">
               <i className="fas "></i>
             </span>
                  <div className="d-flex gap-2 align-items-center justify-content-center">
                    <div>AWS</div>
                    <div
                      className="rounded-circle p-1 bg-success"
                      style={{
                        height: `26px`,
                        width: `${(AWSResourceCount > 99) ? 'fit-content' : '26px'}`,
                        color: "white"
                      }}>
                      {AWSResources?.total_resource_count}
                    </div>
                  </div>
                </a>
              </li>
            }


            {(integrated_systems.includes('Azure') && AzureResources) &&
              <li onClick={() => chooseResourceType('Azure')} className="nav-item">
                <a className={`${currentType === 'Azure' && 'active'} nav-link`}>
                  <span className="d-block d-sm-none">
                    <i className="fas fas-home"></i>
                  </span>
                  <div className="d-flex gap-2 align-items-center justify-content-center">
                    <div>Azure</div>
                    <div className="rounded-circle py-1 bg-success"
                         style={{
                           height: "26px",
                           width: `${(AzureResourceCount > 99) ? 'fit-content' : '26px'}`,
                           color: "white"
                         }}>
                      {AzureResources?.total_resource_count}
                    </div>
                  </div>
                </a>
              </li>
            }

            {(integrated_systems.includes('GCP') && GCPResources) &&
              <li onClick={() => chooseResourceType('GCP')} className="nav-item">
                <a className={`${currentType === 'GCP' && 'active'} nav-link`}>
                  <span className="d-block d-sm-none">
                    <i className="fas fas-home"></i>
                  </span>
                  <div className="d-flex gap-2 align-items-center justify-content-center">
                    <div>GCP</div>
                    <div className="rounded-circle py-1 bg-success"
                         style={{
                           color: "white",
                           height: "26px",
                           width: `${(GCPResourceCount > 99) ? 'fit-content' : '26px'}`
                         }}>
                      {GCPResources?.total_resource_count}
                    </div>
                  </div>
                </a>
              </li>
            }

            {(integrated_systems.includes('Datadog') && DatadogResources) &&
              <li onClick={() => chooseResourceType('Datadog')} className="nav-item">
                <a className={`${currentType === 'Datadog' && 'active'} nav-link`}>
                  <span className="d-block d-sm-none">
                    <i className="fas fas-home"></i>
                  </span>
                  <div className="d-flex gap-2 align-items-center justify-content-center">
                    <div>Datadog</div>
                    <div className="rounded-circle py-1 bg-success"
                         style={{
                           color: "white",
                           height: "26px",
                           width: `${(DatadogResourceCount > 99) ? 'fit-content' : '26px'}`
                         }}>
                      {DatadogResources?.total_resource_count}
                    </div>
                  </div>
                </a>
              </li>
            }

            {integrated_systems.includes('NewRelic') && NewRelicResources &&
              <li onClick={() => chooseResourceType('NewRelic')} className="nav-item">
                <a className={`${currentType === 'NewRelic' && 'active'} nav-link`}>
                  <span className="d-block d-sm-none">
                    <i className="fas fas-home"></i>
                  </span>
                  <div className="d-flex gap-2 align-items-center justify-content-center">
                    <div>NewRelic</div>
                    <div className="rounded-circle py-1 bg-success"
                         style={{
                           height: "26px",
                           width: `${(NRResourceCount > 99) ? 'fit-content' : '26px'}`,
                           color: "white"
                         }}>{NewRelicResources?.total_resource_count}
                    </div>
                  </div>
                </a>
              </li>
            }

            {integrated_systems.includes('AppDynamics') && AppDynamicsResources &&
              <li onClick={() => chooseResourceType('AppDynamics')} className="nav-item">
                <a className={`${currentType === 'AppDynamics' && 'active'} nav-link`}>
                  <span className="d-block d-sm-none">
                    <i className="fas fas-home"></i>
                  </span>
                  <div className="d-flex gap-2 align-items-center justify-content-center">
                    <div>AppDynamics</div>
                    <div className="rounded-circle py-1 bg-success"
                         style={{
                           height: "26px",
                           width: `${(AppDynamicsCount > 99)? 'fit-content' : '26px'}`,
                           color: "white"
                         }}>{AppDynamicsResources?.total_resource_count}
                    </div>
                  </div>
                </a>
              </li>
            }

            {(integrated_systems.includes('Splunk') && SplunkResources) &&
                <li onClick={() => chooseResourceType('Splunk')} className="nav-item">
                  <a className={`${currentType === 'Splunk' && 'active'} nav-link`}>
                    <span className="d-block d-sm-none">
                      <i className="fas "></i>
                    </span>
                    <div className="d-flex gap-2 align-items-center justify-content-center">
                      <div>Splunk</div>
                      <div
                          className="rounded-circle p-1 bg-success"
                          style={{
                            height: `26px`,
                            width: `${(SplunkCount > 99) ? 'fit-content' : '26px'}`,
                            color: "white"
                          }}>
                        {SplunkResources?.total_resource_count}
                      </div>
                    </div>
                  </a>
                </li>
            }
            {(integrated_systems.includes('Dynatrace') && DynatraceResources) &&
                <li onClick={() => chooseResourceType('Dynatrace')} className="nav-item">
                  <a className={`${currentType === 'Dynatrace' && 'active'} nav-link`}>
                  <span className="d-block d-sm-none">
                    <i className="fas fas-home"></i>
                  </span>
                    <div className="d-flex gap-2 align-items-center justify-content-center">
                      <div>Dynatrace</div>
                      <div className="rounded-circle py-1 bg-success"
                           style={{
                             height: "26px",
                             width: `${(DynatraceCount > 99) ? 'fit-content' : '26px'}`,
                             color: "white"
                           }}>
                        {DynatraceResources?.total_resource_count}
                      </div>
                    </div>
                  </a>
                </li>
            }
            {(integrated_systems.includes('Temperstack') && SyntheticsResources) &&
                <li onClick={() => chooseResourceType('Temperstack')} className="nav-item">
                  <a className={`${currentType === 'Temperstack' && 'active'} nav-link`}>
                  <span className="d-block d-sm-none">
                    <i className="fas fas-home"></i>
                  </span>
                    <div className="d-flex gap-2 align-items-center justify-content-center">
                      <div>Synthetics</div>
                      <div className="rounded-circle py-1 bg-success"
                           style={{
                             height: "26px",
                             width: `${(SyntheticsCount > 99) ? 'fit-content' : '26px'}`,
                             color: "white"
                           }}>
                            {SyntheticsResources?.total_resource_count}
                      </div>
                    </div>
                  </a>
                </li>
            }
            {(integrated_systems.includes('OCI') && AWSResources) &&
                <li onClick={() => chooseResourceType('OCI')} className="nav-item">
                  <a className={`${currentType === 'OCI' && 'active'} nav-link`}>
             <span className="d-block d-sm-none">
               <i className="fas "></i>
             </span>
                    <div className="d-flex gap-2 align-items-center justify-content-center">
                      <div>OCI</div>
                      <div
                          className="rounded-circle p-1 bg-success"
                          style={{
                            height: `26px`,
                            width: `${(OciCount > 99) ? 'fit-content' : '26px'}`,
                            color: "white"
                          }}>
                        {OciResources?.total_resource_count}
                      </div>
                    </div>
                  </a>
                </li>
            }
            {integrated_systems.includes('Grafana') && GrafanaResources &&
              <li onClick={() => chooseResourceType('Grafana')} className="nav-item">
                <a className={`${currentType === 'Grafana' && 'active'} nav-link`}>
                  <span className="d-block d-sm-none">
                    <i className="fas fas-home"></i>
                  </span>
                  <div className="d-flex gap-2 align-items-center justify-content-center">
                    <div>Grafana</div>
                    <div className="rounded-circle py-1 bg-success"
                         style={{
                           height: "26px",
                           width: `${(GrafanaCount > 99)? 'fit-content' : '26px'}`,
                           color: "white"
                         }}>{GrafanaResources?.total_resource_count}
                    </div>
                  </div>
                </a>
              </li>
            }
            {integrated_systems.includes('Signoz') && SignozResources &&
              <li onClick={() => chooseResourceType('Signoz')} className="nav-item">
                <a className={`${currentType === 'Signoz' && 'active'} nav-link`}>
                  <span className="d-block d-sm-none">
                    <i className="fas fas-home"></i>
                  </span>
                  <div className="d-flex gap-2 align-items-center justify-content-center">
                    <div>Signoz</div>
                    <div className="rounded-circle py-1 bg-success"
                         style={{
                           height: "26px",
                           width: `${(SignozCount > 99)? 'fit-content' : '26px'}`,
                           color: "white"
                         }}>{SignozResources?.total_resource_count}
                    </div>
                  </div>
                </a>
              </li>
            }
          </ul>
        </div>

        {count[currentType] > itemsPerPage &&
          <Pagination aria-label="pagination navigation" listClassName="justify-content-end pagination-rounded" className="me-1">
            {totalPages > 1 && (
              <PaginationItem key={Math.max(selectedPage - 1, 1)} disabled={selectedPage === 1}>
                <PaginationLink
                  href=""
                  onClick={() => handlePageClick(Math.max(selectedPage - 1, 1))}
                >
                  <i className="mdi mdi-chevron-left"/>
                </PaginationLink>
              </PaginationItem>
            )}
            {[...Array(endPage - startPage + 1)].map((_, index) => (
              <PaginationItem key={startPage + index} active={selectedPage === startPage + index}>
                <PaginationLink href="" onClick={() => handlePageClick(startPage + index)}>
                  {startPage + index}
                </PaginationLink>
              </PaginationItem>
            ))}
            {totalPages > 1 && (
              <PaginationItem key={Math.min(selectedPage + 1, totalPages)} disabled={selectedPage === totalPages}>
                <PaginationLink
                  href=""
                  onClick={() => handlePageClick(Math.min(selectedPage + 1, totalPages))}
                >
                  <i className="mdi mdi-chevron-right"/>
                </PaginationLink>
              </PaginationItem>
            )}
          </Pagination>
        }
      </div>

      <ResourcesTable
        height={height}
        maxHeight={maxHeight}
        type={currentType}
        getNotificationServiceMapping={getNotificationServiceMapping}
        resources={
          currentType === 'AWS' ? AWSResources?.resources:
            (currentType === 'Azure' ? AzureResources?.resources:
              (currentType === 'GCP' ? GCPResources?.resources:
                (currentType === 'NewRelic' ? NewRelicResources?.resources:
                  (currentType==='Dynatrace' ? DynatraceResources?.resources :
                    (currentType === 'Splunk' ? SplunkResources?.resources :
                      (currentType === 'Temperstack' ? SyntheticsResources?.resources :
                        (currentType === 'OCI' ? OciResources?.resources:
                          (currentType === 'Datadog' ? DatadogResources?.resources :
                            (currentType === 'Grafana' ? GrafanaResources?.resources :
                              (currentType === 'Signoz' ? SignozResources?.resources :
                              AppDynamicsResources?.resources))))))))))}
      />
    </React.Fragment>
  );
}

export default RecentlyAddedResources;